var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 39,
    viewBox: "0 0 23 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11982 1.07604L22.3209 18.226C22.525 18.4302 22.6693 18.6514 22.7537 18.8896C22.8394 19.1278 22.8823 19.383 22.8823 19.6552C22.8823 19.9274 22.8394 20.1826 22.7537 20.4208C22.6693 20.659 22.525 20.8802 22.3209 21.0844L5.11982 38.2854C4.64343 38.7618 4.04795 39 3.33337 39C2.61878 39 2.00628 38.7448 1.49587 38.2344C0.985449 37.724 0.730242 37.1285 0.730242 36.4479C0.730242 35.7674 0.985449 35.1719 1.49587 34.6615L16.5021 19.6552L1.49587 4.64896C1.01948 4.17257 0.781282 3.58593 0.781282 2.88904C0.781282 2.19079 1.03649 1.58646 1.54691 1.07604C2.05732 0.56562 2.65281 0.310413 3.33337 0.310413C4.01392 0.310413 4.60941 0.56562 5.11982 1.07604Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.e4b533a9d1cd65bfd5dd92f9cc76fedf.svg";
export { ForwardRef as ReactComponent };